import { findAsArray, first } from '../common/domUtils';

export function clickToExpand() {
	const elements = findAsArray('.js-click-to-expand');

	const handleSingleton = (event, target, toggleClass) => {
		event.preventDefault();
		const element = first(target);
		if (!element) {
			return;
		}

		const isExpanded = element.classList.contains(toggleClass);
		findAsArray(`.${toggleClass}`).map((x) => x.classList.remove(toggleClass));
		if (!isExpanded) {
			element.classList.add(toggleClass);
		}
	};

	const handleDynamic = (event, target, toggleClass) => {
		event.preventDefault();
		findAsArray(target).map((x) => x.classList.toggle(toggleClass));

		var element = document.getElementById("globalmenu");
		const isGlobalmenuExpanded = element.classList.contains(toggleClass);

		if (isGlobalmenuExpanded) {
			element.style.display = "block";
			const globalMenuCloseBtn = document.getElementById("globalmenu__close-button");
			globalMenuCloseBtn.focus();
		} else {
			element.style.display = "none";
			const globalMenuOpenBtn = document.getElementById("globalmenu__open-button");
			globalMenuOpenBtn.focus();
		}
	};

	elements.map((element) => {
		const { target, toggleclass: toggleClass, singleton, autoclose } = element.dataset;

        if (!target || !toggleClass) {
			console.log('Misconfigured clickToExpand element', element);
			return;
		}

		if (singleton && singleton === 'true') {
            element.addEventListener('click', (e) => handleSingleton(e, target, toggleClass));
		} else {
			element.addEventListener('click', (e) => handleDynamic(e, target, toggleClass));
        }
        
        if (autoclose && autoclose === 'true') {
            document.addEventListener('mousedown', (e) => {
                if(element.contains(e.target)) {
                    return;
                }

                const targetElement = first(target);
                if(targetElement && !targetElement.contains(e.target)) {
                    targetElement.classList.remove(toggleClass);
                }
            });
        }

	});
}
